import Product360 from "./product-360";

export default Product360;
